import emailjs from '@emailjs/browser'

function send(to_email, subject, html_content) {
  const template_params = {
    to_email,
    from_name: '慧智瞳',
    reply_to: 'no_reply',
    html_content,
    subject,
  }
  try {
    return emailjs.send(
      process.env.REACT_APP_EMAILJS_SERVICE_ID,
      process.env.REACT_APP_EMAILJS_TEMPLATE_ID,
      template_params,
      process.env.REACT_APP_EMAILJS_PUBLIC_KEY
    )
  } catch (error) {
    console.error(`寄送失敗：${error}`)
  }
}

export function sendCustomerMessage(formValue) {
  const { company_name, name, email, message } = formValue
  const to_email = process.env.REACT_APP_TARGET_MAIL
  const subject = '【慧智瞳】顧客留言通知'
  const html_content = `
    <h3>顧客留言</h3>
    <p>公司名稱：${company_name}</p>
    <p>姓名：${name}</p>
    <p>E-mail：${email}</p>
    <p>訊息：${message}</p>
    `
  return send(to_email, subject, html_content)
}
